import { moduleRequest } from '@/utils/request'

let _request
const getRequest = () => {
	if (!_request) _request = moduleRequest(`/sys/dataStatistic/`)
	return _request
}

export default {
	uvAdd(data) {
		return getRequest()('uvAdd', data, 'post')
	},
	pvAdd(data) {
		return getRequest()('pvAdd', data, 'post')
	},
}
